import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Trans } from '@lingui/react'
import { colorSuccess, colorWarning, colorError, colorInfos } from '../../styles/theme'
import useAppState from '../hooks/useAppState'
import Tooltip from '../util/Tooltip'
import Icon from '../util/Icon'

const BannerComponent = ({ bannerContent }) => {
    const navigate = useNavigate()
    const { currentUser, setDelegatedUser} = useAppState()

    const handleAction = (type) => {
        switch (type) {
            case 'missing_link': 
            case 'userSubstitution': 
                return setDelegatedUser({delegatedUser : currentUser})
            case 'review_access':
            case 'renew_access':
            case 'azureAdLogin':
                return navigate('/profile', { state: { source: 'banner' } })
            default:
                return null
        }
    }

    const statusColors = {
        warning: colorWarning,
        error: colorError,
        infos: colorSuccess,
    }

    const getbackgroundColor = (banner) => {
        switch (banner.type) {
            case 'azureAdLogin':
                return '#F3CACA'
            case 'userSubstitution':
                return colorInfos                
            default:
                return '#f8f3d6'
        }
    }

    const getIconAccentColor = (banner) => {
        switch (banner.type) {
            case 'azureAdLogin':
            case 'userSubstitution':
                return '#f76262'              
            default:
                return '#dcbe2a'
        }
    }

        const getContentColor = (banner) => {
        switch (banner.type) {
            case 'userSubstitution':
                return 'white'              
            default:
                return 'black'
        }
    }

    const getTooltipLabel = (banner) => {
        switch (banner.type) {
            case 'userSubstitution':
                return <Trans id="Switch back" />              
            default:
                return 'black'
        }
    }

    const stylingBanner = (banner) => {
        switch (banner.type) {
            case 'input_warning':
                return 'pl-1 pt-1 pb-1'             
            case 'userSubstitution':
                return 'z-[1] sticky top-[50px] mr-3 ml-3 mb-0 justify-center p-2'   
            default:
                return 'mr-3 ml-3 mb-0 justify-center p-2'
        }
    }

    if (bannerContent.length === 0) return null
    return bannerContent.length && bannerContent.map((banner)=><div
            style={{backgroundColor:getbackgroundColor(banner)}}
            className={`${stylingBanner(banner)} flex items-center `}  
        >
            <Icon
                name = {banner.type === 'userSubstitution' ? "userSubstitution" : "bannerWarning" }
                accentColor={getIconAccentColor(banner)}
                className="mr-2"
                aria-hidden="true"
                isSmall={banner.type === 'input_warning' || banner.type === 'userSubstitution' }  
            />
            <p className={`b text-${getContentColor(banner)}`}>{banner.content}</p>
            <Tooltip show={banner.type === 'userSubstitution'} position="bottom" label={getTooltipLabel(banner)}>
            <button
                className={`ml-1 text-[#f76262] font-semibold hover:underline ${banner.type === 'userSubstitution' && 'text-lg'}`}
                type="button"
                onClick={()=>handleAction(banner.type)}
            >
                {banner.actionContent?.message}
            </button>
            </Tooltip>
        </div>
    )
}

export default BannerComponent
